import { styled } from "styled-components";
import { DropDown } from "../../../public/assets";
import { Hrule } from "../../pages/AddUserPage/AddUser";
import { Label, LabelAndInfo } from "./InputContainer";
import fipayFonts from "../../theme/index";

export interface CustomSelectProps {
  selectedOption: string;
  showList: boolean;
  options: string[];
  selectOption: (option: string) => void;
  placeHolder: string;
  toggleShowList: () => void;
  label: string;
  width?: string;
}

const CustomSelect: React.FC<CustomSelectProps> = ({
  selectedOption,
  showList,
  options,
  selectOption,
  placeHolder,
  toggleShowList,
  label,
  width,
}) => {
  return (
    <Wrapper $width={width}>
      <Label htmlFor={label}>
        {label}
        <DropdownWrapper onClick={toggleShowList}>
          <SelectedText $selected={selectedOption !== ""}>
            {selectedOption || placeHolder}
          </SelectedText>
          <DownArrow src="/assets/svg/dropDown.svg" $showing={showList} />
          {showList && (
            <OptionsList>
              {options.map((option) => (
                <ListItem key={option} onClick={() => selectOption(option)}>
                  {option}
                  <Hrule />
                </ListItem>
              ))}
            </OptionsList>
          )}
        </DropdownWrapper>
      </Label>
    </Wrapper>
  );
};

export const Wrapper = styled.div<{ $width?: string }>`
  width: ${({ $width }) => $width};
  @media only screen and (max-width: 767px) {
    width: 100%;
  }
`;
export const DropdownWrapper = styled.div<{ $width?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  cursor: pointer;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  padding: 12px;
`;

export const SelectedText = styled.span<{ $selected?: boolean }>`
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  font-family: "Gt Walsheim Pro", sans-serif;

  color: ${({ $selected }) => ($selected ? "#0e0e0e" : "#6C6C6C")};
`;

export const DownArrow = styled.img<{ $showing?: boolean }>`
  transform: rotate(${({ $showing }) => ($showing ? 180 : 0)}deg);
`;

export const OptionsList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 120%;
  background-color: #fff;
  width: 100%;
  border: 1px solid #e2e2e2;
  z-index: 1;
  border-radius: 15px;
  left: 0;
`;

export const ListItem = styled.span`
  color: #444448;
  padding: 0.5rem 1rem;

  &:hover {
    background-color: #e9eaf9;
    border-radius: 15px;
  }
`;
export default CustomSelect;
